import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e15ad142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-full pt-2 z-10" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "label-primary flex gap-1.5 relative z-10" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = ["type", "min", "max", "placeholder"]
const _hoisted_6 = ["onMousedown", "onMouseenter"]
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_8 = { class: "text-xs text-critical-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.changeCase(_ctx.label, _ctx.ElementE.LABEL)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          ref: "inputRef",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          class: _normalizeClass(["h-[46px] p-3 border border-gray-300 rounded-lg text-sm text-neutral-125 w-full z-5", [
            _ctx.isOptionsListVisible && 'border-red-500',
            _ctx.errors.customValue && 'border-critical'
          ]]),
          type: _ctx.validateAsNumber ? 'number' : 'text',
          min: _ctx.validateAsNumber ? _ctx.min : undefined,
          max: _ctx.validateAsNumber ? _ctx.max : undefined,
          placeholder: _ctx.placeholder,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onKeydown: [
            _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
            _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEscape && _ctx.onEscape(...args)), ["escape"])),
            _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["arrow-down"])),
            _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["arrow-up"]))
          ],
          onKeypress: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onKeypress && _ctx.onKeypress(...args)))
        }, null, 42, _hoisted_5), [
          [_vModelDynamic, _ctx.inputValue]
        ]),
        (_ctx.isOptionsListVisible && _ctx.filteredValues.length > 0)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: _normalizeClass(["absolute w-full top-full mt-1 border border-gray-300 rounded-lg bg-white shadow-lg z-10", 
            _ctx.filteredValues.length > 3 ? 'h-[180px] overflow-y-scroll' : 'overflow-hidden'
          ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredValues, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  ref_for: true,
                  ref: 'option-' + index,
                  class: _normalizeClass(["p-3 text-sm text-neutral-125 cursor-pointer hover:bg-neutral-0", [
              String(item.name) === _ctx.inputValue ? 'bg-neutral-25' : 'bg-white',
              index === _ctx.highlightedIndex && 'bg-neutral-25'
            ]]),
                  onMousedown: _withModifiers(($event: any) => (_ctx.selectItem(item)), ["prevent"]),
                  onMouseenter: ($event: any) => (_ctx.highlightedIndex = index)
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ], 42, _hoisted_6))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (_ctx.errors.customValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors.customValue), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_click_outside, _ctx.clickOutside]
  ])
}